import React from 'react';
import '../styles/Action.css'
function callAction() {
 
  return <section className='Action'>
     <h3>
         Boost your links today
    </h3>
    <aside style={{textAlign:'center'}}>
    <button>
        Get Started
    </button>
    </aside>
  </section>;
}

export default callAction;


